<div class="visualization-tile">
  <div class="tile-header">
    <div class="tile-header-title">Risk Map</div>
  </div>
  <div class="tile-content">
    <div  *ngIf="lineChartData.length>0" class="riskmap-chart" style="height:100%">
      <canvas baseChart #baseChart="base-chart"
        [datasets]="lineChartData"
        [options]="lineChartOptions"
        [legend]="lineChartLegend"
        [chartType]="lineChartType"
        (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked($event)">
      </canvas>
    </div>
  </div>
</div>
